// Entry point for the build script in your package.json
//! v1.0
import "@hotwired/turbo-rails"
import "./controllers"

import * as Turbo from "@hotwired/turbo"

Turbo.StreamActions.busy = function () {
  this.targetElements.forEach((e) => {
    e.setAttribute("busy", "")
  })
}

Turbo.StreamActions.visit = function () {
  Turbo.visit(this.getAttribute("location"))
}

window.addEventListener("anythingllm-embed-session-expired", () => {
  window.location.href = "/users/sign_in"
})

document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault()
  console.error(
    "[Turbo] Frame missing — frame:",
    event.target.id,
    event.detail.response,
  )
})
